import React, { memo } from 'react';

import {translate} from '@mapsight/ui/src/js/helpers/i18n';

import {useNavPos} from '../../hooks';

const footerEntries = {
	de: [
		{
			title: 'Startseite',
			url: 'https://www.stade-tourismus.de/de/'
		},
		{
			title: 'Erklärung zur Barrierefreiheit',
			url: 'https://www.stade-tourismus.de/de/service/rechtliches/erklaerung-zur-barrierefreiheit/',
		},

		{
			title: 'Impressum',
			url: 'https://www.stade-tourismus.de/de/service/rechtliches/impressum/',
		},
		{
			title: 'Datenschutz',
			url: 'https://www.stade-tourismus.de/de/service/rechtliches/datenschutz/',
			popup: true,
		},

		{
			title: 'Pressekontakt',
			url: 'https://www.stade-tourismus.de/de/service/pressebereich/',
		},
		{
			title: 'AGB',
			url: 'https://www.stade-tourismus.de/de/service/rechtliches/allgemeine-geschaeftsbedingungen/',
		},
	],
	en: [
		{
			title: 'Start Page (german)',
			url: 'https://www.stade-tourismus.de/de/',
		},
		{
			title: 'Imprint (german)',
			url: 'https://www.stade-tourismus.de/de/service/rechtliches/impressum/',
		},
		{
			title: 'Data Protection Disclaimer (german)',
			url: 'https://www.stade-tourismus.de/de/service/rechtliches/datenschutz/',
			popup: true,
		},

		{
			title: 'Press Contact (german)',
			url: 'https://www.stade-tourismus.de/de/service/pressebereich/',
		},
		{
			title: 'Terms of Business (german)',
			url: 'https://www.stade-tourismus.de/de/service/rechtliches/allgemeine-geschaeftsbedingungen/',
		},
	]
};

function PageFooter() {
	const navPos = useNavPos();
	const entries = navPos.app?.lang === 'en' ? footerEntries.en : footerEntries.de;

	return (
		<section className="stade-page-footer">
			<h2 className="visuallyhidden">{translate('stade.footer', navPos.app?.lang)}</h2>

			<nav className="stade-page-footer__nav">
				<ul className="stade-page-footer__link-list">
					{entries.map((e,i) => (
						<li key={i} className="stade-page-footer__link-entry">
							<a
								target={e.popup?'blank':undefined}
								href={e.url}
								className="stade-page-footer__link"
							>
								{e.title}
							</a>
						</li>
					))}
				</ul>
			</nav>
		</section>
	);
}

export default memo(PageFooter);
